// 路由拦截方法
export const applyRouterGuard = (router) => {
    router.beforeEach(async (to, from, next) => {
        const query = to.query || {};
        if (query.token) localStorage.setItem('authorization', query.token);
        if (query.grayKey) localStorage.setItem('grayKey', query.grayKey);
        if (query.requestSource) localStorage.setItem('requestSource', query.requestSource);
        next();
    });
}
